import type { GatsbyBrowser } from "gatsby"
import React from "react"
import "./src/styles/global.css"
import { SearchProvider } from "./src/components/search/SearchProvider"
import { initPlatformEnv, applyDom } from "./src/lib/platformEnv"

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return React.createElement(SearchProvider, null, element)
}

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  // The browser's own native scroll restoration (separate from Gatsby's JS-level
  // shouldUpdateScroll below) otherwise re-applies whatever scroll offset it has
  // cached for a URL you'd previously visited and scrolled down on — which is
  // what made some doc links land mid-page instead of at the top. Turning it off
  // hands scroll position fully over to shouldUpdateScroll.
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }

  void initPlatformEnv()

  // Load additional font weights on idle
  if (typeof window !== "undefined" && 'requestIdleCallback' in window) {
    requestIdleCallback(() => {
      import('@fontsource/open-sans/600.css')
      import('@fontsource/open-sans/700.css')
    }, { timeout: 3000 })
  }
}


export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({ routerProps: { location } }) => {
  if (location.hash) return false // let anchor-link navigation scroll to the heading instead
  return [0, 0]
}

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  if (typeof window === "undefined") return
  requestAnimationFrame(() => applyDom())
  if (location.hash) return
  requestAnimationFrame(() => {
    requestAnimationFrame(() => window.scrollTo(0, 0))
  })
}

export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] = () => {
  if (typeof window !== "undefined") {
    document.body.classList.remove('loading')
  }
}
